import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.StandardCeilingHeight];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Standard Ceiling Height
      </PageHeader>

      <InputRow {...page} keyName={LocationVarKey.StandardCeilingHeight} label="Standard Ceiling Height" />
    </>
  );
}
